<style scoped>
/* Style the input fields */
.step {
  cursor: pointer;
}

input,
select {
  padding: 10px !important;
  width: 100% !important;
  font-size: 17px !important;
  /* font-family: Raleway !important; */
  font-family: var(--customization_font_family);
  background-color: transparent;
  outline: 0 !important;
  border: 1px solid #d4dfe4 !important;
  border-right: none !important;
  border-radius: 0px !important;
}

.form_color {
  height: 40px;
  max-width: 100px;
  border: 1px solid gray !important;
}


label {
  text-transform: capitalize;
  font-family: var(--customization_label_font_family);
  /* font-family: "Courier New", Courier, monospace; */
}

.radio #radio-group-1,
.checkbox #checkbox-group-1 {
  display: inline-block;
}

.radio .radio-tooltip {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50% !important;
  width: 25px !important;
  height: 25px !important;
  font-size: 12px !important;
}

.tooltip-button {
  border: 1px solid #d4dfe4;
  border-left: none;
  border-radius: 0px !important;
}

.input,
.file,
.select,
.textarea {
  display: flex;
}

.textarea {
  margin-top: 20px;
}

textarea,
select,
textarea:focus,
textarea:hover {
  font-size: 17px;
  /* font-family: Raleway; */
  font-family: var(--customization_font_family);
  background-color: transparent;
  outline: 0;
  border: 1px solid #d4dfe4 !important;
  border-right: none;
}
.textarea_height{
  height: 200px;
}

/* Mark input boxes that gets an error on validation: */
.invalid {
  background-color: #ffdddd;
}

/* Hide all steps by default: */
.tab {
  display: none;
}


/* Make circles that indicate the steps of the form: */
.step {
  height: 35px;
  width: 35px;
  margin: 0 2px;
  border: none;
  border-radius: 50%;
  display: inline-block;
  opacity: 0.4;
}

/* Mark the active step: */
.step.active {
  opacity: 1;
}

/* Mark the steps that are finished and valid: */
.step.finish {
  background-color: #04aa6d;
}
.card-header{
  border: none;
  font-family: var(--customization_font_family);
}
.card-body{
  font-family: var(--customization_font_family);
}
.textarea_height, textarea{
  height: 200px !important;
  background-color: red !important;
}
</style>

<template scoped>

  <div v-if="pages.length > 0" 
    :style="{ 
        '--customization_custom_background': customization.custom_background , 
        '--customization_custom_color': customization.custom_color,
        '--customization_font_family': customization.font_family,
        '--customization_label_font_family': customization.label_font_family,
        '--customization_button_border_color': customization.button_border_color,
        '--customization_button_border': customization.button_border,
      }"
    class="container mt-5 p-3 card shadow-md">

    <app-overlay-loader v-if="preloader" />
    <div class="card-header" :style="{ backgroundColor: customization.custom_background, color: customization.custom_color }">
      <h4 class="text-uppercase font-weight-bold">
        {{ formname }}
      </h4>
    </div>

    <div class="card-body">
      <form action="">
        <!-- Circles which indicates the steps of the form: -->
        <div class="row d-flex justify-content-center mt-2" style="text-align: center">
          <span :style="{ backgroundColor: customization.button_background, color: customization.button_color }" @click="showTab(index)" v-for="(page, index) in pages" class="
                                    step
                                    d-flex
                                    align-items-center
                                    justify-content-center
                                  " data-toggle="tooltip" data-placement="top" :title="page.name">{{ index + 1 }}
          </span>
        </div>

        <!-- One "tab" for each step in the form: -->
        <div class="tab" v-for="(page, index) in pages" :key="page.id">
          <h5 class="mt-4 mb-4 text-capitalize">{{ page.name }}</h5>
          <div class="mb-5" v-html="page.step_description"></div>
          <div class="row">
            <div v-if="page.custom_values.length<=0" class="w-100 text-center mt-4 pt-4 mb-4 pb-4">
              <h3 class="text-center text-warning mt-4 pt-4 mb-4 pb-4 ">
                You need to create customs values on this acccount.
              </h3>
            </div>
            <div v-else class="col-lg-12" v-for="(custom_value, val_index) in Object.values(page.custom_values)"
              :key="custom_value.id">
              <!--select-->
              <div v-if="'select' ===
                custom_value_type(custom_value.custom_field_type_id)
                ">
                <label for="" class="d-block">{{
                  custom_value.field_name
                }}</label>
                <p class="select">
                  <select class="" oninput='this.classList.remove("invalid")' :class="{ required: custom_value.required }"
                    :name="custom_value.field_name" :ref="custom_value.field_name"
                    v-model="field_values[index][val_index].value" @change="setCustomValue(
                          field_values[index][val_index].value,
                          custom_value
                        )
                        ">
                    <option disabled :value="''" selected="selected">
                      Please select an option
                    </option>
                    <option v-for="element in custom_value.choices.split(';')" :key="element" :value="element">
                      {{ element }}
                    </option>
                  </select>

                  <button :id="'parent' + index + val_index" type="button"
                    @click="showToolTip('#SpeechBubble' + index + val_index)" class="shadow-sm">
                    <i class="fas fa-info"></i>
                  </button>

                  <div class="SpeechBubble" speech-bubble pright atop style="--bbColor:#929292"
                    :id="'SpeechBubble' + index + val_index">
                    <div class="explanation"><span v-html="custom_value.description ?? custom_value.field_name"></span></div>
                  </div>
                </p>
              </div>

              <!--multi-select-->
              <div v-if="'multi-select' ===
                custom_value_type(custom_value.custom_field_type_id)
                ">
                <label for="" class="d-block">{{
                  custom_value.field_name
                }}</label>

                <p class="select">
                  <multiselect :name="custom_value.field_name" :ref="custom_value.field_name" :multiple="true"
                    :clear-on-select="false" :preserve-search="true" placeholder="Please select option"
                    v-model="field_values[index][val_index].value" @input="setCustomValue(
                          field_values[index][val_index].value,
                          custom_value
                        )
                        " :preselect-first="false" :close-on-select="false" :options="custom_value.choices.split(';')">
                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single"
                        v-if="values.length > 0 && !isOpen">{{ values.length }} options selected</span></template>
                  </multiselect>

                  <button :id="'parent' + index + val_index" type="button"
                    @click="showToolTip('#SpeechBubble' + index + val_index)" class="shadow-sm SpeechBubbleParent">
                    <i class="fas fa-info"></i>
                  </button>

                <div class="SpeechBubble" speech-bubble pright atop style="--bbColor:#929292"
                  :id="'SpeechBubble' + index + val_index">
                  <div class="explanation"><span v-html="custom_value.description ?? custom_value.field_name"></span></div>
                </div>
                </p>
              </div>

              <!--text-->
              <div v-if="['text', 'number', 'password', 'date'].includes(
                  custom_value_type(custom_value.custom_field_type_id)
                )
                " class="mb-2">
                <label for="" class="d-block">{{
                  custom_value.field_name
                }}</label>

                <p class="input">
                  <span class="input-group-prepend" v-if="custom_value.prefix">
                    <span class="input-group-text" style="height: 47.5px;">{{ custom_value.prefix }}</span>
                  </span>
                  
                  <input class="shadow-sm " :class="{ required: custom_value.required }"
                    v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)"
                    :type="custom_value_type(custom_value.custom_field_type_id)" :placeholder="custom_value.field_name"
                    :readonly="true" :ref="custom_value.field_name" :name="custom_value.field_name" @change="setCustomValue(
                          getFieldOperationValue(
                            operations_values[custom_value.field_key].operand1,
                            operations_values[custom_value.field_key].operand2,
                            operations_values[custom_value.field_key].operator,
                            operations_values[custom_value.field_key].type
                          ),
                          custom_value
                        )
                        " :value="getFieldOperationValue(
          operations_values[custom_value.field_key].operand1,
          operations_values[custom_value.field_key].operand2,
          operations_values[custom_value.field_key].operator,
          operations_values[custom_value.field_key].type
        )
        " oninput='this.classList.remove("invalid")' />

                  <input class="shadow-sm form-control" :class="{ required: custom_value.required }" v-else
                    :type="custom_value_type(custom_value.custom_field_type_id)" :placeholder="custom_value.field_name"
                    :ref="custom_value.field_name" :name="custom_value.field_name"
                    v-model="field_values[index][val_index].value" @input="setCustomValue(
                          field_values[index][val_index].value,
                          custom_value
                        )
                        " oninput='this.classList.remove("invalid")' />
                  <span class="input-group-append" v-if="custom_value.suffix">
                    <span class="input-group-text">{{ custom_value.suffix }}</span>
                  </span>

                  <button :id="'parent' + index + val_index" type="button"
                    @click="showToolTip('#SpeechBubble' + index + val_index)" class="shadow-sm">
                    <i class="fas fa-info"></i>
                  </button>

                <div class="SpeechBubble" speech-bubble pright atop style="--bbColor:#929292"
                  :id="'SpeechBubble' + index + val_index">
                  <div class="explanation"><span v-html="custom_value.description ?? custom_value.field_name"></span></div>
                </div>
                </p>
              </div>

              <!--color picker-->
              <div v-if="'Color picker' ===
                  custom_value_type(custom_value.custom_field_type_id)
                  ">
                <div class="mb-4">
                  <label class="d-block">
                    {{ custom_value.field_name }}
                  </label>
                  <div v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)">
                    <input type="color" class="form_color" disabled :readonly="true" :ref="custom_value.field_name" :name="custom_value.field_name"
                    @change="setCustomValue(
                          getFieldOperationValue(
                            operations_values[custom_value.field_key].operand1,
                            operations_values[custom_value.field_key].operand2,
                            operations_values[custom_value.field_key].operator,
                            operations_values[custom_value.field_key].type
                          ),
                          custom_value
                        )
                        " :value="getFieldOperationValue(
          operations_values[custom_value.field_key].operand1,
          operations_values[custom_value.field_key].operand2,
          operations_values[custom_value.field_key].operator,
          operations_values[custom_value.field_key].type
        )
        " />
                    <input type="text" disabled class="form_color"  :readonly="true" 
                    :ref="custom_value.field_name" :name="custom_value.field_name"
                    @change="setCustomValue(
                          getFieldOperationValue(
                            operations_values[custom_value.field_key].operand1,
                            operations_values[custom_value.field_key].operand2,
                            operations_values[custom_value.field_key].operator,
                            operations_values[custom_value.field_key].type
                          ),
                          custom_value
                        )
                        " :value="getFieldOperationValue(
          operations_values[custom_value.field_key].operand1,
          operations_values[custom_value.field_key].operand2,
          operations_values[custom_value.field_key].operator,
          operations_values[custom_value.field_key].type
        )
        " 
                    />
                  </div>

                  <div v-else>
                    <input type="color" class="form_color" v-model="field_values[index][val_index].value" @input="setCustomValue(
                          field_values[index][val_index].value,
                          custom_value
                        )
                        " />
                    <input type="text" class="form_color" v-model="field_values[index][val_index].value" @input="setCustomValue(
                          field_values[index][val_index].value,
                          custom_value
                        )
                        " />
                  </div>

                </div>
              </div>

              <!--file-->
              <div class="mb-4" v-if="'File' ===
                custom_value_type(custom_value.custom_field_type_id)
                ">
                <File :custom_value="custom_value" />
              </div>

              <!--textarea-->
              <div v-if="'textarea' ==
                custom_value_type(custom_value.custom_field_type_id)
                " class="mb-2">
                <label for="" class="d-block">{{
                  custom_value.field_name
                }}</label>

                <p class="textarea">
                    <app-input 
                    v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)" 
                        custom-config
                        type="textarea"
                        class="shadow-sm w-100 " 
                        :removeClass="true"
                        inputClass="textarea_height"
                        :required="true"
                        :id="'textarea-id' + index + val_index"
                        :label="custom_value.field_name"
                        :class="{ required: custom_value.required }"
                        :name="custom_value.field_name" 
                        :ref="custom_value.field_name"
                        
                        @input="setCustomValue(
                          getFieldOperationValue(
                            operations_values[custom_value.field_key].operand1,
                            operations_values[custom_value.field_key].operand2,
                            operations_values[custom_value.field_key].operator,
                            operations_values[custom_value.field_key].type
                          ),
                          custom_value
                        )
                        " :value="getFieldOperationValue(
                            operations_values[custom_value.field_key].operand1,
                            operations_values[custom_value.field_key].operand2,
                            operations_values[custom_value.field_key].operator,
                            operations_values[custom_value.field_key].type
                          )"
                        oninput='this.classList.remove("invalid")'
                        :placeholder="custom_value.field_name" 
                      />

                  
                        <app-input v-else
                        custom-config
                        type="textarea"
                        class="shadow-sm w-100 " 
                        :removeClass="true"
                        inputClass="textarea_height"
                        :required="true"
                        :id="'textarea-id' + index + val_index"
                        :key="'text-editor-id' + index + val_index"
                        :label="custom_value.field_name"
                        :class="{ required: custom_value.required }"
                        :name="custom_value.field_name" 
                        :ref="custom_value.field_name"
                        v-model="field_values[index][val_index].value"
                        @input="setCustomValue(
                          field_values[index][val_index].value,
                          custom_value
                        )
                        " 
                        oninput='this.classList.remove("invalid")'
                        :placeholder="custom_value.field_name" 
                      />

                  <button :id="'parent' + index + val_index" type="button"
                    @click="showToolTip('#SpeechBubble' + index + val_index)" class="shadow-sm SpeechBubbleParent">
                    <i class="fas fa-info"></i>
                  </button>

                <div class="SpeechBubble" speech-bubble pright atop style="--bbColor:#929292"
                  :id="'SpeechBubble' + index + val_index">
                  <div class="explanation"><span v-html="custom_value.description ?? custom_value.field_name"></span></div>
                </div>
                </p>

              </div>

              <!--text editor-->
              <div v-if="'text-editor' ==
                custom_value_type(custom_value.custom_field_type_id)
                " class="mb-2">
                <label for="" class="d-block">{{
                  custom_value.field_name
                }}</label>

                <p class="textarea">
                    <app-input 
                    v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)" 
                        custom-config
                        type="text-editor"
                        class="shadow-sm w-100 " 
                        :required="true"
                        :id="'text-editor-id' + index + val_index"
                        :label="custom_value.field_name"
                        :class="{ required: custom_value.required }"
                        :name="custom_value.field_name" 
                        :ref="custom_value.field_name"
                        
                        @input="setCustomValue(
                          getFieldOperationValue(
                            operations_values[custom_value.field_key].operand1,
                            operations_values[custom_value.field_key].operand2,
                            operations_values[custom_value.field_key].operator,
                            operations_values[custom_value.field_key].type
                          ),
                          custom_value
                        )
                        " :value="getFieldOperationValue(
                            operations_values[custom_value.field_key].operand1,
                            operations_values[custom_value.field_key].operand2,
                            operations_values[custom_value.field_key].operator,
                            operations_values[custom_value.field_key].type
                          )"
                        oninput='this.classList.remove("invalid")'
                        :placeholder="custom_value.field_name" 
                      />

                  
                        <app-input v-else
                        custom-config
                        type="text-editor"
                        class="shadow-sm w-100 " 
                        :required="true"
                        :id="'text-editor-id' + index + val_index"
                        :key="'text-editor-id' + index + val_index"
                        :label="custom_value.field_name"
                        :class="{ required: custom_value.required }"
                        :name="custom_value.field_name" 
                        :ref="custom_value.field_name"
                        v-model="field_values[index][val_index].value"
                        @input="setCustomValue(
                          field_values[index][val_index].value,
                          custom_value
                        )
                        " 
                        oninput='this.classList.remove("invalid")'
                        :placeholder="custom_value.field_name" 
                      />

                  <button :id="'parent' + index + val_index" type="button"
                    @click="showToolTip('#SpeechBubble' + index + val_index)" class="shadow-sm SpeechBubbleParent">
                    <i class="fas fa-info"></i>
                  </button>

                <div class="SpeechBubble" speech-bubble pright atop style="--bbColor:#929292"
                  :id="'SpeechBubble' + index + val_index">
                  <div class="explanation"><span v-html="custom_value.description ?? custom_value.field_name"></span></div>
                </div>
                </p>

              </div>

              <!--radio-->
              <div v-if="'radio' ===
                  custom_value_type(custom_value.custom_field_type_id)
                  ">
                <label for="" class="d-block">{{
                  custom_value.field_name
                }}</label>

                <p class="radio">

                <div class="form-check form-check-inline" v-for='(item, item_index) in (custom_value.choices.split(";"))'>
                  <input class="form-check-input" oninput='this.classList.remove("invalid")'
                    :class="{ required: custom_value.required }" :ref="custom_value.field_name"
                    :name="custom_value.field_name" v-model="field_values[index][val_index].value" @change="setCustomValue(
                          field_values[index][val_index].value,
                          custom_value
                        )
                        " type="radio" :id="'inlineRadio' + item_index" :value="item">
                  <label class="form-check-label" :for="'inlineRadio' + item_index"> {{ item }}</label>
                </div>

                <button :id="'parent' + index + val_index" type="button"
                  @click="showToolTip('#SpeechBubble' + index + val_index)" class="shadow-sm">
                  <i class="fas fa-info"></i>
                </button>

                <div class="SpeechBubble" speech-bubble pright atop style="--bbColor:#929292"
                  :id="'SpeechBubble' + index + val_index">
                  <div class="explanation"><span v-html="custom_value.description ?? custom_value.field_name"></span></div>
                </div>
                </p>
              </div>

              <!--checkbox-->
              <div v-if="'checkbox' ===
                custom_value_type(custom_value.custom_field_type_id)
                ">
                <label for="" class="d-block">{{
                  custom_value.field_name
                }}</label>

                <p class="checkbox">
                <div class="form-check form-check-inline" v-if="custom_value.choices.includes('#single:')">
                  <input class="form-check-input mt-4" id="checkbox-1" oninput='this.classList.remove("invalid")'
                    :class="{ required: custom_value.required }" :ref="custom_value.field_name"
                    v-model="field_values[index][val_index].value" @change="setCustomValue(
                          field_values[index][val_index].value,
                          custom_value
                        )
                        " :value="custom_value.choices
          .replace(/#multiple:|#single:/gi, '')
          .split(';')[0]
        " :unchecked-value="custom_value.choices
          .replace(/#multiple:|#single:/gi, '')
          .split(';')[1]
        " type="checkbox">
                  <label class="form-check-label" for="inlineCheckbox1">{{ custom_value.field_name }}</label>
                </div>

                <div class="form-check form-check-inline" v-if="custom_value.choices.includes('#multiple:')"
                  v-for='(item, item_index) in custom_value.choices.replace(/#multiple:|#single:/gi, "").split(";")'>
                  <input class="form-check-input mt-4" :id="item" :class="{ required: custom_value.required }"
                    :ref="custom_value.field_name" v-model="field_values[index][val_index].value" @change="setCustomValue(
                        field_values[index][val_index].value,
                        custom_value
                      )
                      " oninput='this.classList.remove("invalid")' type="checkbox" :value="item">
                  <label class="form-check-label" for="'item'">{{ item }}</label>
                </div>
                <button :id="'parent' + index + val_index" type="button"
                  @click="showToolTip('#SpeechBubble' + index + val_index)" class="shadow-sm ">
                  <i class="fas fa-info"></i>
                </button>

                <div class="SpeechBubble" speech-bubble pright atop style="--bbColor:#929292"
                  :id="'SpeechBubble' + index + val_index">
                  <div class="explanation"><span v-html="custom_value.description ?? custom_value.field_name"></span></div>
                </div>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="row d-flex justify-content-between px-3" style="overflow: auto">
          <div class="">
            <button 
              :style="{ 
                backgroundColor: customization.button_background, 
                color: customization.button_color ,
                borderColor: customization.button_border_color,
                borderWidth: customization.button_border+'px'
              }" 
              class="btn btn-outline" 
              :disabled="preloader || filePreloader" type="button" id="prevBtn"
              @click="nextPrev(-1)">
              Previous
            </button>
          </div>
          <div class="d-flex justify-content-end">
            <button 
              :style="{ 
                backgroundColor: customization.button_background, 
                color: customization.button_color ,
                borderColor: customization.button_border_color,
                borderWidth: customization.button_border+'px'
              }" 
             v-if="currentTab < pages.length - 1" class="btn mr-2" type="button" id="nextBtn"
              :disabled="preloader || filePreloader" @click="nextPrev(1, true)">
              Save
            </button>
            <button  
              :style="{ 
                backgroundColor: customization.button_background, 
                color: customization.button_color ,
                borderColor: customization.button_border_color,
                borderWidth: customization.button_border+'px'
              }" 
            class="btn" type="button" id="nextBtn" :disabled="preloader || filePreloader"
              @click="nextPrev(1)">
              <span v-if="currentTab < pages.length - 1">Next</span>
              <span v-else>Save</span>
            </button>
          </div>
        </div>
      </form>
    </div>

    <dialog id="dialog">
      <h2>{{ modalName }}</h2>
      <p>{{ modalDescription }}</p>
      <button @click="HideToolTip" aria-label="close" class="x">❌</button>
    </dialog>


  </div>
  <div v-else class="w-100 text-center mt-4 pt-4">
    <h3 class="text-center text-warning mt-4 pt-4">
      You need to add pages and customs values on your application.
    </h3>
    <a :href="urlGenerator('app/custom')" type="button" class="btn btn-primary btn-with-shadow mt-4">
      custom values
    </a>
  </div>
</template>
<script scoped>

import { urlGenerator } from "../../../Helpers/AxiosHelper";
import Verte from 'verte';
import coreLibrary from "../../../../core/helpers/CoreLibrary";
import 'verte/dist/verte.css';
import Multiselect from "vue-multiselect";
import File from "./components/file.vue";

export default {
  props: [
    "pages",
    "custom_field_types",
    "operations",
    "action",
    "originalCustomValues",
    "customization",
    "formname"
  ],
  components: { Multiselect, verte: Verte, File },

  data() {
    return {
      urlGenerator,
      modalName: "",
      modalDescription: "",
      preloader: false,
      filePreloader: false,
      currentTab: 0,
      field_values: [],
      operations_values: [],
      operations_index: [],
      field_index: [],
      page_index: [],

      customValues: [],
    };
  },

  created() {

    this.reorderPage();

    this.pages.forEach((page, page_index) => {
      let data = [];
      let page_custom_values = Object.values(page.custom_values);
      page_custom_values.forEach((custom_value, index) => {
        if (custom_value.choices == null || custom_value.choices == "") {
          if (custom_value.value == null || custom_value.value == "") {
            data.push({ value: custom_value.default_value ?? "" });
            custom_value.value = custom_value.default_value ?? "";
          } else {
            if (
              typeof custom_value.value == "number" ||
              typeof custom_value.value == "string"
            ) {
              data.push({ value: this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value ?? "") });
            } else {
              data.push({ value: custom_value.default_value ?? "" });
              custom_value.value = custom_value.default_value ?? "";
            }
          }
        } else {
          if (custom_value.choices.split(";").includes(custom_value.value)) {
            if (
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "checkbox" ||
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "multi-select"
            ) {
              if (custom_value.choices.includes("#single:")) {
                data.push({
                  value: custom_value.value,
                });
              } else {
                data.push({ value: custom_value.value.split(";") });
              }
            } else {
              data.push({ value: custom_value.value });
            }
          } else {
            if (
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "checkbox" ||
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "multi-select"
            ) {
              if (custom_value.choices.includes("#single:")) {
                data.push({
                  value: custom_value.default_value,
                });

                custom_value.value = custom_value.default_value;
              } else {
                if (custom_value.default_value != null) {
                  data.push({ value: custom_value.default_value.split(";") });
                  custom_value.value = custom_value.default_value.split(";");
                } else {

                  data.push({ value: "" });
                  custom_value.value = "";
                }
              }
            } else {
              if (custom_value.default_value != null) {

                data.push({ value: custom_value.default_value });
                custom_value.value = custom_value.default_value;
              } else {

                data.push({ value: "" });
                custom_value.value = "";
              }
            }
          }
        }
        this.field_index[custom_value.fieldKey] = index;
        this.page_index[custom_value.fieldKey] = page_index;
      });


      this.field_values.push(data);
    });

    this.operations.forEach((operation) => {
      this.operations_values[operation.result] = {
        operand1: operation.operand1,
        operand2: operation.operand2,
        operator: operation.operator,
        type: operation.type,
        value: operation.type,
      };
      this.operations_index.push(operation.result);
    });

  },

  mounted() {
    this.showTab(0); // Display the current tab
  },
  methods: {
    hasOperation(fieldKey, field_key){
      return this.operations_index.includes(fieldKey) || this.operations_index.includes(field_key);
    },
    showToolTip(_child) {
      let explanations = document.querySelectorAll(".SpeechBubble");

      let child = document.querySelector(_child);
      var scaleX = child.getBoundingClientRect().width / child.offsetWidth;
      if (scaleX == 0) {
        explanations.forEach(element => {
          element.style.animationName = "shrink";
          element.style.animationDuration = "0.1s";
        });

        child.style.animationName = "expand-bounce";
        child.style.animationDuration = "0.25s";
      } else {
        child.style.animationName = "shrink";
        child.style.animationDuration = "0.1s";
      }
    },

    hideToolTip(_child) {
      let child = document.querySelector(_child);
      child.style.animationName = "shrink";
      child.style.animationDuration = "0.1s";
    },


    ShowToolTip(name, description) {
      this.modalName = name;
      this.modalDescription = description;
      window.dialog.showModal();
    },

    HideToolTip() {
      this.modalName = "";
      this.modalDescription = "";
      window.dialog.close();
    },

    reorderPage() {
      this.pages.sort((a, b) => {
        if (a.position < b.position) {
          return -1;
        }
        if (a.position > b.position) {
          return 1;
        }

        return 0;
      });
    },

    goTo(tab, n) {
      var x = document.getElementsByClassName("tab");

      alert(tab + " " + this.currentTab);
      if (tab == this.currentTab) {

      } else {
        x[tab].style.display = "none";
        // Increase or decrease the current tab by 1:
        this.currentTab = tab + n;

        // Otherwise, display the correct tab:
        this.showTab(this.currentTab);
      }
    },

    compare(a, b) {
      if (a.custom_field_type_id < b.custom_field_type_id) {
        return -1;
      }
      if (a.custom_field_type_id > b.custom_field_type_id) {
        return 1;
      }
      return 0;
    },

    reoderCustomValues(customValues) { },

    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    createBase64(event, custom) {
      let file = event.target.files ? event.target.files[0] : null;
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          custom.value = event.target.result;
          custom.file_name = file.name;
        };
        reader.readAsDataURL(file);
      }
    },

    setCustomValue(value, custom) {
      if (
        this.custom_value_type(custom.custom_field_type_id) == "multi-select" ||
        this.custom_value_type(custom.custom_field_type_id) == "checkbox"
      ) {
        if (custom.choices.includes("#single:")) {
          custom.value = value;
        } else {
          custom.value = value.join(";");
        }
      } else {
        custom.value = value;
      }
    },

    getFieldOperationValue(operand1, operand2, operator, type) {
      let op1;
      let op2;

      var operand1_without_space = operand1.replace(/\s+/g, "");
      var operand2_without_space = operand2.replace(/\s+/g, "");

      if (this.field_index[operand1] !== undefined) {
        op1 =
          this.field_values[this.page_index[operand1]][
            this.field_index[operand1]
          ].value;
      }
      else if (this.field_index[operand1_without_space] !== undefined) {
        // alert('2')
        op1 =
          this.field_values[this.page_index[operand1_without_space]][
            this.field_index[operand1_without_space]
          ].value;
      } 
       else {
        // alert('3')
        op1 = this.findOperationValue(operand1);
      }

      if (this.field_index[operand2] !== undefined) {
        op2 =
          this.field_values[this.page_index[operand2]][
            this.field_index[operand2]
          ].value;
      } 
      else if (this.field_index[operand2_without_space] !== undefined) {
        op2 =
          this.field_values[this.page_index[operand2_without_space]][
            this.field_index[operand2_without_space]
          ].value;
      }
      else {
        op2 = this.findOperationValue(operand2);
      }

      return this.makeOperation(type, operator, op1, op2);
    },

    makeOperation(type, operator, op1, op2) {
      if (type == "concat") {
        return op1 + "" + op2;
      } else if (type == "math") {
        op1 = parseFloat(op1);
        op2 = parseFloat(op2);

        if (isNaN(op1)) {
          op1 = 0;
        }
        if (isNaN(op2)) {
          op2 = 0;
        }

        if (operator == "addition") {
          return op1 + op2;
        } else if (operator == "substraction") {
          return op1 - op2;
        } else if (operator == "division") {
          return op1 / op2;
        } else if (operator == "multiplication") {
          return op1 * op2;
        }
      }
    },

    next(tab, n) {
      var x = document.getElementsByClassName("tab");
      x[tab].style.display = "none";
      // Increase or decrease the current tab by 1:
      this.currentTab = tab + n;

      // Otherwise, display the correct tab:
      this.showTab(this.currentTab);
    },

    custom_value_type(id) {
      let type = this.custom_field_types.filter(
        (el) => parseInt(el.id) === parseInt(id)
      );
      return type[0].name;
    },

    showTab(n) {

      this.title = this.pages[n].name;
      // This will display the specified tab of the form ...
      var x = document.getElementsByClassName("tab");

      x[n].style.display = "block";

      if (n != this.currentTab) {
        x[this.currentTab].style.display = "none";
      }

      // ... and fix the Previous/Next buttons:
      if (n == 0) {
        document.getElementById("prevBtn").style.display = "none";
      } else {
        document.getElementById("prevBtn").style.display = "inline";
      }

      this.currentTab = n;

      // ... and run a that displays the correct step indicator:
      this.fixStepIndicator(n);
    },

    getOperationId(op) {
      let result;
      if (this.action == "test") {
        result = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
      } else {
        result = this.originalCustomValues.customValues.find(
          ({ fieldKey }) => fieldKey === op
        );
      }
      return result.id;
    },

    getOperationName(op) {
      let result;
      if (this.action == "test") {
        result = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
      } else {
        result = this.originalCustomValues.customValues.find(
          ({ fieldKey }) => fieldKey === op
        );
      }
      return result.name;
    },

    getOperationValue(operation) {
      let op1 = this.findOperationValue(operation.operand1);
      let op2 = this.findOperationValue(operation.operand2);

      return this.makeOperation(operation.type, operation.operator, op1, op2);
    },

    getPrefixValue(prefix){
      if (prefix && prefix.length > 0) {
        return prefix
      } else {
        return ""
      }
    },

    getSuffixValue(suffix){
      if (suffix && suffix.length > 0) {
        return suffix
      } else {
        return ""
      }
    },

    removePrefixSuffixValue(prefix, suffix, value) {
      if (typeof value !== "string") {
        return value
      }
      if (value.startsWith(prefix) && prefix!=null) {
        value = value.substr(prefix.length);
      }

      if (value.endsWith(suffix) && suffix!=null) {
        value = value.substr(0, value.length - suffix.length);
      }
      return value;
    },

    findOperationValue(op) {
      if (this.field_index[op] !== undefined) {
        let op1 =
          this.field_values[this.page_index[op]][
            this.field_index[op]
          ].value;
          return op1;
      }

      let value;
      const result = Object.values(this.pages[this.currentTab].custom_values).find(({ fieldKey }) => fieldKey === op);
      let result1;
      if (result == null) {
        if (this.action == "test") {
          result1 = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
        } else {
          result1 = this.originalCustomValues.customValues.find(
            ({ fieldKey }) => fieldKey === op
          );
        }
        if (result1 == null) {
          value = op;
        } else {
          value = result1.value??'';
        }
      } else {
        value = result.value??'';
      }
      return value;
    },

    nextPrev(n, change = false) {
      // This will figure out which tab to display

      var x = document.getElementsByClassName("tab");
      if (this.currentTab < x.length - 1 || n == -1) {
        // Exit the if any field in the current tab is invalid:
        if (n == 1 && !this.validateForm()) return false;
        else if (n == 1 && this.validateForm()) {
          this.customValues = [];

          Object.values(this.pages[this.currentTab].custom_values).forEach(
            (custom_value, val_index) => {

              const operation = this.operations.find(
                ({ result }) => result === custom_value.fieldKey
              );

              if (operation == null) {
                this.customValues.push({
                  id: custom_value.cv_id,
                  fieldKey: custom_value.fieldKey,
                  field_type: this.custom_value_type(custom_value.custom_field_type_id),
                  name: custom_value.name,
                  value:
                  this.getPrefixValue(custom_value.prefix)+
                    (typeof custom_value.value == "object"
                      ? this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value.join(";"))
                      : this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value.split('\n').join(' ')))+this.getSuffixValue(custom_value.suffix),
                });
              } else {
                this.customValues.push({
                  id: custom_value.cv_id,
                  fieldKey: custom_value.fieldKey,
                  field_type: this.custom_value_type(custom_value.custom_field_type_id),
                  name: custom_value.name,
                  value: this.getPrefixValue(custom_value.prefix)+this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, this.getOperationValue(operation))+this.getSuffixValue(custom_value.suffix),
                });
              }
            }
          );

          if (this.pages.length < 2) {
            let customs = [];
            this.pages.forEach((page) => {
              customs.push(...Object.values(page.custom_values));
            });

            this.operations.forEach((operation) => {
              const result = customs.find(
                ({ fieldKey }) => fieldKey === operation.result
              );

              if (result == null) {
                this.customValues.push({
                  id: this.getOperationId(operation.result),
                  fieldKey: operation.result,
                  field_type: '',
                  name: this.getOperationName(operation.result),
                  value: this.getOperationValue(operation),
                });
              }

            });
          }

          if (change) {
            this.$emit("save", this.action, this.customValues, this.currentTab, n, change);
          } else {
            this.$emit("save", this.action, this.customValues, this.currentTab, n, false);
          }
        }
        if (n == -1) {
          // Hide the current tab:
          x[this.currentTab].style.display = "none";
          // Increase or decrease the current tab by 1:
          this.currentTab = this.currentTab + n;

          // Otherwise, display the correct tab:
          this.showTab(this.currentTab);
        }
      }
      // if you have reached the end of the form... :
      else {
        if (n == 1 && !this.validateForm()) return false;
        //...the form gets submitted:
        //document.getElementById("regForm").submit();

        this.customValues = [];
        Object.values(this.pages[this.currentTab].custom_values).forEach(
          (custom_value, val_index) => {
            
            const operation = this.operations.find(
              ({ result }) => result === custom_value.fieldKey
            );

            if (operation == null) {
              
              this.customValues.push({
                id: custom_value.cv_id,
                fieldKey: custom_value.fieldKey,
                field_type: this.custom_value_type(custom_value.custom_field_type_id),
                name: custom_value.name,
                value: this.getPrefixValue(custom_value.prefix)+
                  (typeof custom_value.value == "object"
                    ? this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value.join(";"))
                    : this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value.split('\n').join(' ')))
                    +this.getSuffixValue(custom_value.suffix),
              });
            } else {
              
              this.customValues.push({
                id: custom_value.cv_id,
                fieldKey: custom_value.fieldKey,
                field_type: this.custom_value_type(custom_value.custom_field_type_id),
                name: custom_value.name,
                value: this.getPrefixValue(custom_value.prefix)+this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, this.getOperationValue(operation))+this.getSuffixValue(custom_value.suffix),
              });
            }
          }
        );

        let customs = [];
        this.pages.forEach((page) => {
          customs.push(...Object.values(page.custom_values));
        });

        this.operations.forEach((operation) => {
          const result = customs.find(
            ({ fieldKey }) => fieldKey === operation.result
          );

          if (result == null) {
            this.customValues.push({
              id: this.getOperationId(operation.result),
              fieldKey: operation.result,
              field_type: '',
              name: this.getOperationName(operation.result),
              value: this.getOperationValue(operation),
            });
          }

        });

        this.$emit("save", this.action, this.customValues, this.currentTab, n, true);
        return false;
      }
    },

    validateForm() {
      // This deals with validation of the form fields
      var x,
        y,
        textarea,
        i,
        valid = true;
      x = document.getElementsByClassName("tab");
      y = x[this.currentTab].getElementsByClassName("required");

      // A loop that checks every input field in the current tab:
      for (i = 0; i < y.length; i++) {
        // If a field is empty...
        if (y[i].value == "") {
          // add an "invalid" class to the field:
          y[i].classList.add("invalid");
          // and set the current valid status to false:
          valid = false;
        }
      }

      // If the valid status is true, mark the step as finished and valid:
      if (valid) {
        document.getElementsByClassName("step")[this.currentTab].className +=
          " finish";
      }
      return valid; // return the valid status
    },

    fixStepIndicator(n) {
      // This removes the "active" class of all steps...
      var i,
        x = document.getElementsByClassName("step");
      for (i = 0; i < x.length; i++) {
        x[i].className = x[i].className.replace(" active", "");
      }
      //... and adds the "active" class to the current step:
      x[n].className += " active";
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
/* width */
.explanation::-webkit-scrollbar {
  width: 2px;
}

/* Track */
.explanation::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.explanation::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
.explanation::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.explanation {
  max-height: 200px;
  overflow-y: scroll;
  padding-right: 10px;
}

[speech-bubble] {
  --bbColor: grey;
  --bbArrowSize: 1.5rem;
  --bbBorderRadius: 0.25rem;
  --bbPadding: 1rem;
  background: var(--bbColor);
  border-radius: var(--bbBorderRadius);
  padding: var(--bbPadding);
  z-index: 100;
  position: absolute;
  top: 30px;
  right: 35px;
  transform: scale(0);
  animation-fill-mode: forwards;
  max-width: 65vw; 

}

[speech-bubble]::before {
  content: '';
  position: absolute;
  background: var(--bbColor);
}

[speech-bubble][pbottom] {
  margin-bottom: var(--bbArrowSize)
}

[speech-bubble][ptop] {
  margin-top: var(--bbArrowSize);
}

[speech-bubble][pleft] {
  margin-left: var(--bbArrowSize);
}

[speech-bubble][pright] {
  margin-right: var(--bbArrowSize);
}


/* bottom and top  */
[speech-bubble][pbottom]::before,
[speech-bubble][ptop]::before {
  --width: calc(var(--bbArrowSize) / 2 * 3);
  height: var(--bbArrowSize);
  width: var(--width);
}

/* bottom */
[speech-bubble][pbottom]::before {
  top: calc(100% - 2px);
}

[speech-bubble][pbottom][aleft]::before {
  left: 1rem;
  clip-path: polygon(25% 0, 100% 0, 0% 100%)
}

[speech-bubble][pbottom][acenter]::before {
  left: calc(50% - var(--width) / 2);
  clip-path: polygon(12.5% 0, 87.5% 0, 50% 100%)
}

[speech-bubble][pbottom][aright]::before {
  right: 1rem;
  clip-path: polygon(0 0, 75% 0, 100% 100%)
}

/* top */
[speech-bubble][ptop]::before {
  bottom: calc(100% - 2px);
}

[speech-bubble][ptop][aleft]::before {
  left: var(--bbPadding);
  clip-path: polygon(0 0, 100% 100%, 25% 100%)
}

[speech-bubble][ptop][acenter]::before {
  left: calc(50% - var(--width) / 2);
  clip-path: polygon(12.5% 100%, 50% 0, 87.5% 100%)
}

[speech-bubble][ptop][aright]::before {
  right: var(--bbPadding);
  clip-path: polygon(0 100%, 100% 0, 75% 100%)
}

/* left and right  */
[speech-bubble][pleft]::before,
[speech-bubble][pright]::before {
  --height: calc(var(--bbArrowSize) / 2 * 3);
  width: var(--bbArrowSize);
  height: var(--height);
}

/* right */
[speech-bubble][pright]::before {
  left: calc(100% - 2px);
}

[speech-bubble][pright][atop]::before {
  top: var(--bbPadding);
  clip-path: polygon(100% 0, 0 100%, 0 25%)
}

[speech-bubble][pright][acenter]::before {
  top: calc(50% - var(--height) / 2);
  clip-path: polygon(0 12.5%, 100% 50%, 0 87.5%)
}

[speech-bubble][pright][abottom]::before {
  bottom: var(--bbPadding);
  clip-path: polygon(0 0, 100% 100%, 0 75%)
}

/* left */
[speech-bubble][pleft]::before {
  right: calc(100% - 2px);
}

[speech-bubble][pleft][atop]::before {
  top: var(--bbPadding);
  clip-path: polygon(0 0, 100% 25%, 100% 100%)
}

[speech-bubble][pleft][acenter]::before {
  top: calc(50% - var(--height) / 2);
  clip-path: polygon(0 50%, 100% 12.5%, 100% 87.5%);
}

[speech-bubble][pleft][abottom]::before {
  bottom: var(--bbPadding);
  clip-path: polygon(0 100%, 100% 0, 100% 75%)
}

/* flip */
[speech-bubble][pbottom][flip]::before,
[speech-bubble][ptop][flip]::before {
  transform: scaleX(-1)
}

[speech-bubble][pleft][flip]::before,
[speech-bubble][pright][flip]::before {
  transform: scaleY(-1)
}


@keyframes expand-bounce {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}

/* Here the scale simply goes from 1 back to 0 */
@keyframes shrink {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0);
  }
}





/*Dialog Styles*/
dialog,
.bubble_container {
  padding: 1rem 3rem;
  background: white;
  max-width: 800px;
  padding-top: 2rem;
  border-radius: 20px;
  border: 0;
  box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1);
  -webkit-animation: fadeIn 1s ease both;
  animation: fadeIn 1s ease both;
}

dialog::-webkit-backdrop {
  -webkit-animation: fadeIn 1s ease both;
  animation: fadeIn 1s ease both;
  background: rgba(255, 255, 255, 0.4);
  z-index: 2;
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
}

dialog::backdrop {
  -webkit-animation: fadeIn 1s ease both;
  animation: fadeIn 1s ease both;
  background: rgba(255, 255, 255, 0.4);
  z-index: 2;
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
}

dialog .x {
  filter: grayscale(1);
  border: none;
  outline: none;
  background: none;
  position: absolute;
  top: 15px;
  right: 10px;
  transition: ease filter, transform 0.3s;
  cursor: pointer;
  transform-origin: center;
}

dialog .x:hover {
  filter: grayscale(0);
  transform: scale(1.1);
}

dialog h2 {
  font-weight: 600;
  font-size: 1.5rem;
  padding-bottom: 1rem;
}

dialog p {
  font-size: 1rem;
  line-height: 1.3rem;
  padding: 0.5rem 0;
}

dialog p a:visited {
  color: rgb(var(--vs-primary));
}

/*General Styles*/

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}


.multiselect__tags {
  background-color: transparent !important;
  min-height: 42px !important;
  padding: 12px 40px 0 5px !important;
  outline: 0 !important;
  border: 1px solid #d4dfe4 !important;
  border-right: none !important;
  border-radius: 0px !important;
}

.multiselect__option--selected,
.multiselect__option--highlight,
.multiselect__option--highlight:hover,
.multiselect__content .multiselect__option:hover {
  background-color: blue !important;
  color: white !important;
}

.multiselect__select {
  padding: 30px 8px;
}
</style>
